import { TipoDeRecurso } from '@/models/Recurso';
import { tituloDaToolbarPeloNomeDaRota } from '@/shareds/router-shareds';
import { RouteConfig } from "vue-router";

const rotasDeEventos: RouteConfig[] = [
	{
		path: '/events',
		name: 'Logs',
		components: {
			default: () =>
				import('@/views/application/log/TelaDeEventos.vue'),
			toolbar: () =>
				import('@/components/layout/AppToolbarComTitulo.vue'),
		},
		props: {
			toolbar: tituloDaToolbarPeloNomeDaRota,
		},
		meta: {
			recurso: 'tela-de-eventos' as TipoDeRecurso,
		},
	},
]

export default rotasDeEventos